import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <Seo
        title="Page Not Found – Bhutan Morning Teer Result"
        description="The page you are looking for could not be found on bhutanmorningteerresult.in."
        path="/404"
      />
      <div
        data-testid="not-found"
        className="mx-auto flex max-w-xl flex-col items-center px-4 py-16 text-center"
      >
        <p className="text-7xl font-extrabold text-[#1ab5a3]">404</p>
        <h1 className="mt-3 text-2xl font-bold text-[#10161f]">
          Page Not Found
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          data-testid="back-home"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1ab5a3] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#0f9b8a]"
        >
          <HomeIcon size={16} /> Back to Home
        </Link>
      </div>
    </Layout>
  );
}
